module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        showColorBar: true,
        tabConfigNavKey: 'trips',
        parentEntityPreparationGranted: false,
    },

    methods: {
        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            tabOptions.title = entityAttributes.title || ''
            tabOptions.titleSuffix = ` [ ${entityID} ]`

            if(tabOptions.title.length > 50){
                tabOptions.title = `${tabOptions.title.substring(0, 50)}...`
            }

            return tabOptions
        },
    },
}